export const DATA_EXPLORER_SIMULATE_CLASSNAME = 'data-explorer-simulate';
